module.exports = __webpack_public_path__ + "static/assets/825efb8616528b0a1ed8fe7d6f325408.svg";